var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.691 6.51071L12.7529 1.44861C13.0824 1.11934 13.0824 0.586962 12.7529 0.257693C12.4237 -0.0715749 11.8913 -0.0715749 11.562 0.257693L6.49993 5.31979L1.43799 0.257693C1.10856 -0.0715749 0.576336 -0.0715749 0.247067 0.257693C-0.0823557 0.586962 -0.0823557 1.11934 0.247067 1.44861L5.30901 6.51071L0.247067 11.5728C-0.0823557 11.9021 -0.0823557 12.4345 0.247067 12.7637C0.411162 12.928 0.626921 13.0105 0.842526 13.0105C1.05813 13.0105 1.27374 12.928 1.43799 12.7637L6.49993 7.70163L11.562 12.7637C11.7263 12.928 11.9419 13.0105 12.1575 13.0105C12.3731 13.0105 12.5887 12.928 12.7529 12.7637C13.0824 12.4345 13.0824 11.9021 12.7529 11.5728L7.691 6.51071Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.dbe44d1a.svg";
export { ForwardRef as ReactComponent };